import Model from 'src/storage/list';

class TreatmentDetailFilesModel extends Model {
  id = 'TreatmentDetailFilesModel';
  persistent = false;
  listPersistent = false;
  defaultState = () => ({
    current: 'recent'
  });
  apiConfig = {
    list: {
      url: 'message/files',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    refresh: {
      url: 'message/files',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'messageRefresh'
    }
  };
  idKey = 'counter';

  listLimit = 30;

  sortBy = {
    key: 'counter',
    desc: true
  };

  load = (partnerId, otherPartnerId) => {
    this.setStateSilent({ partnerId, otherPartnerId });
    this.refresh();
  };

  listParams(loadMore) {
    const partnerId = this.state.partnerId;
    if (!partnerId) return null;

    let req = {
      partnerId,
      otherPartnerId: this.state.otherPartnerId,
      limit: this.listLimit,
      skip: 0
    };
    if (loadMore) {
      let skip = this.items().length;
      if (skip < this.listLimit) return null;
      req.skip = skip;
    }
    return req;
  }
}

export default new TreatmentDetailFilesModel();
